import axios, {AxiosInstance, AxiosRequestConfig} from "axios";

const config: AxiosRequestConfig = {
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        Accept: "application/json",
        'content-type': 'application/json',
        "x-api-key": process.env.REACT_APP_SQO_API_KEY,
        "x-api-secret": process.env.REACT_APP_SQO_SECRET_KEY,
        "ngrok-skip-browser-warning": 123
    }
}

const initApi: AxiosInstance = axios.create(config)

export default initApi
